module.exports = __webpack_public_path__ + "media/images/undraw/reserve/notify-bd8a77a4f46e8820d1be0f7b8adfbdcc.png";